import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CloudOff, Trash2 } from "lucide-react";
import { listOfflineModules, removeModuleOffline } from "@/lib/offline";
import { usePrefs } from "@/context/PrefsContext";

export function OfflineList({ standalone = false }) {
  const { prefs } = usePrefs();
  const jp = prefs.lang === "jp";
  const [items, setItems] = useState([]);
  const load = () => listOfflineModules().then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items.length) return standalone ? <p className="text-sm text-muted-foreground" data-testid="offline-empty">{jp ? "オフライン保存された教材はありません。" : "Belum ada modul yang disimpan offline. Buka modul lalu tekan 'Simpan offline'."}</p> : null;
  return (
    <section className="soft-card p-5" data-testid="offline-list">
      <div className="flex items-center gap-2"><CloudOff className="h-4 w-4 text-sage" /><h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{jp ? "オフライン保存済み" : "Tersimpan offline"} · {items.length}</h3></div>
      <ul className="mt-3 divide-y divide-border/60">
        {items.map(({ module: m, test, saved_at }) => (
          <li key={m.id} className="flex items-center gap-3 py-2.5" data-testid={`offline-item-${m.id}`}>
            <Link to={`/modules/${m.id}`} className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium"><span className="mr-2 rounded-full bg-foreground px-2 py-0.5 text-[11px] font-semibold text-background">{m.code}</span>{m.title_id}</p>
              <p className="text-[11px] text-muted-foreground">{test ? (jp ? "教材＋ミニテスト＋音声" : "Materi + mini test + audio") : (jp ? "教材のみ" : "Materi saja")} · {new Date(saved_at).toLocaleDateString(jp ? "ja-JP" : "id-ID")}</p>
            </Link>
            <button data-testid={`offline-remove-${m.id}`} onClick={async () => { await removeModuleOffline(m.id); load(); }} className="rounded-full border border-border p-2 text-muted-foreground hover:bg-accent" aria-label="hapus"><Trash2 className="h-3.5 w-3.5" /></button>
          </li>
        ))}
      </ul>
    </section>
  );
}
